import Dialog from "@hudson/ui/components/Dialogs/Simple";
import MinorButton from "@hudson/ui/components/FormFields/ButtonMinor";
import { parentRedirect } from "@hudson/ui/lib/utils";
import FrameConfig from "@lib/classes/FrameConfig";
import Session from "@lib/session";
import useConfig from "@lib/use_config";
import useContent from "@lib/use_content";
import { useSearchParams } from "next/navigation";
import { useState } from "react";
import Login from "./Login";

interface LoginPromptProps {
  className?: string;
}

export default function LoginPrompt({ className = "" }: LoginProps) {
  const searchParams = useSearchParams();

  const { data: cfgData, loading: cfgLoading } = useConfig([
    "epicPassEnabled",
    "groupLoginEnabled",
  ]);
  const { data: contentData } = useContent(["beCouponAppliedMsg", "beGroupLoginPrompt"]);
  const [showDialog, setShowDialog] = useState(false);

  const hideGroupLogin =
    !cfgData?.config.groupLoginEnabled ||
    Session.getBooking().profiles.group ||
    Session.getBooking().profiles.coupon;
  const hideEpicLogin = !cfgData?.config.epicPassEnabled;
  if (hideGroupLogin && hideEpicLogin) return null;

  function gotoBook(profileType, successMsg = "") {
    if (profileType == "COUPON") successMsg = contentData?.content.beCouponAppliedMsg;

    if (searchParams?.get("widget")) {
      let frameConfig = new FrameConfig();
      parentRedirect(`${frameConfig.bookingUrl}?successMsg=${successMsg}` || "");
    } else {
      setShowDialog(false);
      window.location.href = `${process.env.basePath}/${window.siteId}/book?successMsg=${successMsg}`;
    }
  }

  return cfgLoading ? null : (
    <>
      <Dialog maxWidthClass="max-w-md" show={showDialog} onHide={() => setShowDialog(false)}>
        <Login onSuccessfulLogin={gotoBook} showEpic={!hideEpicLogin} showGroup={!hideGroupLogin} />
      </Dialog>
      <div className={className}>
        <MinorButton
          icon={
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              className="w-5 h-5 mr-[2px] relative top-[-1px]"
            >
              <path d="M4.5 6.375a4.125 4.125 0 118.25 0 4.125 4.125 0 01-8.25 0zM14.25 8.625a3.375 3.375 0 116.75 0 3.375 3.375 0 01-6.75 0zM1.5 19.125a7.125 7.125 0 0114.25 0v.003l-.001.119a.75.75 0 01-.363.63 13.067 13.067 0 01-6.761 1.873c-2.472 0-4.786-.684-6.76-1.873a.75.75 0 01-.364-.63l-.001-.122zM17.25 19.128l-.001.144a2.25 2.25 0 01-.233.96 10.088 10.088 0 005.06-1.01.75.75 0 00.42-.643 4.875 4.875 0 00-6.957-4.611 8.586 8.586 0 011.71 5.157v.003z" />{" "}
            </svg>
          }
          className="relative top-[1px] whitespace-nowrap"
          onClick={() => setShowDialog(true)}
          padding="px-2"
          noBorder
        >
          {contentData?.content.beGroupLoginPrompt}
        </MinorButton>
      </div>
    </>
  );
}
